var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dr_detail_wrap"},[_c('div',{staticClass:"dr_detail_title"},[_vm._v(" "+_vm._s(_vm.$t('request_detail'))+" ")]),_c('detection-detail-component',{attrs:{"detection-type":'requestDetail',"detectionKey":_vm.detectionKey}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }